import { decode } from '../../../utils/base64Utils';
import { getBasketItems } from './basket-items';

/**
 * Extracts and transforms user related cookie values
 */
export const createUserProfile = ({
  cached_basket: cachedBasket = '',
  userGreeting,
  shopperId,
  signedIn,
  abwlg,
  'mt.v': monetateId,
} = {}) => ({
  user: {
    basket: {
      items: getBasketItems(cachedBasket),
    },
    greeting: decode(userGreeting),
    signedIn: !!signedIn,
    shopperId,
    guestWishList: !!abwlg,
    monetateId,
  },
});
